// ajay:code 19-08-26
import { useState } from "react";
import { Plus, Trash2, ChevronDown, ChevronRight } from "lucide-react";
import RequirementBlock from "./RequirementBlock";

const emptyRequirement = () => ({ requirement_text: "", failure_modes: [] });

export default function ProcessStepBlock({
  step,
  index,
  onChange,
  onDelete,
  readOnly,
}) {
  const [collapsed, setCollapsed] = useState(false);
  const set = (field, value) => onChange({ ...step, [field]: value });
  const requirements = step.requirements || [];

  const updateRequirement = (i, updated) => {
    const next = [...requirements];
    next[i] = updated;
    set("requirements", next);
  };
  const addRequirement = () =>
    set("requirements", [...requirements, emptyRequirement()]);
  const removeRequirement = (i) =>
    set(
      "requirements",
      requirements.filter((_, idx) => idx !== i),
    );

  return (
    <div
      style={{
        background: "var(--surface)",
        border: "1px solid var(--border)",
        borderRadius: 10,
        marginBottom: 14,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "10px 14px",
          background: "var(--surface2)",
          cursor: "pointer",
        }}
        onClick={() => setCollapsed((v) => !v)}
      >
        {collapsed ? <ChevronRight size={15} /> : <ChevronDown size={15} />}
        <span style={{ fontSize: 11, color: "var(--text3)", fontWeight: 700 }}>
          STEP {index + 1}
        </span>
        {readOnly ? (
          <span style={{ fontSize: 13, fontWeight: 700, flex: 1 }}>
            {step.step_name || "—"}
          </span>
        ) : (
          <input
            type="text"
            value={step.step_name || ""}
            placeholder="e.g. 10. Receipt & Inspection of RM"
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => set("step_name", e.target.value)}
            style={{
              flex: 1,
              padding: "6px 8px",
              fontSize: 13,
              fontWeight: 700,
              borderRadius: 6,
              border: "1px solid var(--border2)",
              background: "var(--surface)",
              color: "var(--text)",
            }}
          />
        )}
        <span style={{ fontSize: 11, color: "var(--text3)" }}>
          {requirements.length} requirement
          {requirements.length !== 1 ? "s" : ""}
        </span>
        {!readOnly && (
          <button
            type="button"
            title="Delete process step"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            style={{
              background: "none",
              border: "none",
              color: "var(--danger)",
              cursor: "pointer",
            }}
          >
            <Trash2 size={15} />
          </button>
        )}
      </div>

      {!collapsed && (
        <div style={{ padding: 14 }}>
          {requirements.map((r, i) => (
            <RequirementBlock
              key={i}
              requirement={r}
              onChange={(updated) => updateRequirement(i, updated)}
              onDelete={() => removeRequirement(i)}
              readOnly={readOnly}
            />
          ))}
          {!readOnly && (
            <button
              type="button"
              onClick={addRequirement}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 4,
                background: "var(--surface2)",
                border: "1px solid var(--border2)",
                borderRadius: 6,
                padding: "6px 12px",
                fontSize: 12,
                fontWeight: 600,
                color: "var(--accent2)",
                cursor: "pointer",
              }}
            >
              <Plus size={13} /> Add Requirement
            </button>
          )}
        </div>
      )}
    </div>
  );
}
